var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isInitLoading,
          expression: "isInitLoading",
        },
      ],
      attrs: {
        id: "content_top",
        block: _vm.isInitLoading,
        "element-loading-background": "rgba(245, 245, 245, 0.96)",
      },
    },
    [
      !_vm.isInitLoading
        ? _c(
            "el-steps",
            {
              attrs: {
                active: _vm.currentStep * 1,
                "align-center": "",
                "finish-status": "success",
                "show-icon": "",
              },
            },
            _vm._l(_vm.stepList, function (itemData, index) {
              return _c("el-step", { key: index, attrs: { title: itemData } })
            }),
            1
          )
        : _vm._e(),
      _c("el-row", { attrs: { justify: "center", type: "flex" } }, [
        _c("div", {
          staticClass: "u-font-xs",
          domProps: { innerHTML: _vm._s(_vm.productName) },
        }),
      ]),
      !_vm.isInitLoading
        ? _c(
            "el-tabs",
            {
              attrs: { "tab-position": "top" },
              model: {
                value: _vm.currentStep,
                callback: function ($$v) {
                  _vm.currentStep = $$v
                },
                expression: "currentStep",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.isPriceLoading,
                      expression: "isPriceLoading",
                    },
                  ],
                  attrs: { label: "", name: "0" },
                },
                [
                  _vm.isShowUnit
                    ? _c(
                        "div",
                        [
                          _c("FormUnitNew", {
                            ref: "refUnitHolder",
                            staticClass: "u-m-b-20",
                            attrs: {
                              applicantFormData:
                                _vm.insureConfigData.applicantForm,
                              "from-type": 1,
                              "insure-type": _vm.insureType,
                              productId: _vm.productId,
                              sourceProductId: _vm.sourceProductId,
                              totalPremium: _vm.totalPremium,
                            },
                            on: {
                              onChangeProductId: _vm.onChangeProductId,
                              onGoToTop: _vm.onGoToTop,
                              onNeedCalcPrice: _vm.onNeedCalcPrice,
                              onSameUnitChange: _vm.onSameUnitChange,
                              onSubmittedData: _vm.onSubmittedDataM,
                              onToChangeInsure: _vm.onToChangeInsure,
                            },
                          }),
                          !_vm.isSameUnit
                            ? _c("FormUnitNew", {
                                ref: "refUnitInsured",
                                staticClass: "u-m-b-20",
                                attrs: {
                                  applicantFormData:
                                    _vm.insureConfigData.insurantForm,
                                  "from-type": 2,
                                  "insure-type": _vm.insureType,
                                  productId: _vm.productId,
                                  sourceProductId: _vm.sourceProductId,
                                },
                                on: {
                                  onChangeProductId: _vm.onChangeProductId,
                                  onNeedCalcPrice: _vm.onNeedCalcPrice,
                                  onSubmittedData: _vm.onSubmittedDataM,
                                  onToChangeInsure: _vm.onToChangeInsure,
                                },
                              })
                            : _vm._e(),
                          _vm.isShowGongBao
                            ? _c("form-unit-insured-new", {
                                ref: "refGongBao",
                                staticClass: "u-m-b-20",
                                attrs: {
                                  "applicant-form-data":
                                    _vm.insureConfigData.applicantForm,
                                  "insure-type": _vm.insureType,
                                  "product-id": _vm.productId,
                                  "source-product-id": _vm.sourceProductId,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.insureConfigData.brandIdForm && !_vm.isAdd
                    ? _c("form-brand-new", {
                        ref: "refBrand",
                        staticClass: "u-m-b-20",
                        attrs: {
                          "brand-form-all-data":
                            _vm.insureConfigData.brandIdForm,
                        },
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "u-m-b-20",
                      staticStyle: { display: "flex" },
                    },
                    [
                      _c("FormPlanNew", {
                        ref: "refPlan",
                        staticClass: "u-m-r-10",
                        staticStyle: { flex: "1" },
                        attrs: {
                          dutyInfoData: _vm.insureConfigData.dutyInfo,
                          "insure-type": _vm.insureType,
                          isAdd: _vm.isAdd,
                          planFormAllData: _vm.insureConfigData.planForm,
                        },
                        on: {
                          onNeedCalcPrice: _vm.onNeedCalcPrice,
                          onSubmittedData: _vm.onSubmittedDataM,
                        },
                      }),
                      _c("FormPeriodNew", {
                        ref: "refPeriod",
                        staticClass: "u-m-l-10",
                        staticStyle: { flex: "1" },
                        attrs: {
                          "add-price-type": _vm.addPriceType,
                          "insure-type": _vm.insureType,
                          "is-add": _vm.isAdd,
                          policyFormAllData: _vm.insureConfigData.orderForm,
                          "product-id": _vm.productId,
                          "source-product-id": _vm.sourceProductId,
                        },
                        on: {
                          onNeedCalcPrice: _vm.onNeedCalcPrice,
                          onPeriodChange: _vm.onCalcPrice,
                          onSubmittedData: _vm.onSubmittedDataM,
                        },
                      }),
                    ],
                    1
                  ),
                  !_vm.isAdd && _vm.isNeedDeclareStart
                    ? _c("FormFileConfirmNew", {
                        ref: "refFiles",
                        attrs: {
                          "declare-form-data": _vm.insureConfigData.declareForm,
                          "insure-type": _vm.insureType,
                          "is-need-declare-start": _vm.isNeedDeclareStart,
                          "product-id": _vm.productId,
                          "source-product-id": _vm.sourceProductId,
                        },
                        on: { onSubmittedData: _vm.onSubmittedDataM },
                      })
                    : _vm._e(),
                  _c("FormEmployeeNew", {
                    ref: "refEmployee",
                    staticClass: "u-m-b-20",
                    attrs: {
                      "act-type": _vm.actType,
                      empFormAllData: _vm.insureConfigData.empForm,
                      "insure-type": _vm.insureType,
                      "is-more": _vm.isMore,
                      onConfirmAllData: _vm.onConfirmAllData,
                      "order-id": _vm.orderId,
                      "product-id": _vm.productId,
                      "source-product-id": _vm.sourceProductId,
                      "total-price": _vm.totalPremium,
                      unitFormAllData: _vm.insureConfigData.applicantForm,
                    },
                    on: {
                      onClearAllData: _vm.onClearAllData,
                      onNeedCalcPrice: _vm.onNeedCalcPrice,
                      onSubmittedData: _vm.onSubmittedDataM,
                    },
                  }),
                  !_vm.isAdd && !_vm.isNeedDeclareStart
                    ? _c("FormFileConfirmNew", {
                        ref: "refFiles",
                        attrs: {
                          "declare-form-data": _vm.insureConfigData.declareForm,
                          "insure-type": _vm.insureType,
                          "is-need-declare-start": _vm.isNeedDeclareStart,
                          "product-id": _vm.productId,
                          "source-product-id": _vm.sourceProductId,
                        },
                        on: { onSubmittedData: _vm.onSubmittedDataM },
                      })
                    : _vm._e(),
                  _vm.insureConfigData.attachForm
                    ? _c("form-attach", {
                        ref: "refAttach",
                        staticClass: "u-m-b-20",
                        attrs: {
                          attachFormAllData: _vm.insureConfigData.attachForm,
                        },
                      })
                    : _vm._e(),
                  _c("FormInvoiceNew", {
                    ref: "refInvoice",
                    staticClass: "u-m-b-20",
                    attrs: {
                      insureType: _vm.insureType,
                      "is-add": _vm.isAdd,
                      "is-more": _vm.isMore,
                      "product-id": _vm.productId,
                      "source-product-id": _vm.sourceProductId,
                      "total-premium": _vm.totalPremium,
                    },
                  }),
                  _c("insure-notices-new", {
                    ref: "refInsureNotices",
                    attrs: {
                      insureType: _vm.insureType,
                      "is-add": _vm.isAdd,
                      "is-can-scroll": _vm.isCanScroll,
                      productId: _vm.productId,
                      "protocol-info-data": _vm.insureConfigData.protocolInfo,
                      sourceProductId: _vm.sourceProductId,
                    },
                    on: {
                      onFirstStepConfirm: _vm.onStepConfirmInsure,
                      onInsureReadOver: _vm.onInsureReadOver,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.isPriceLoading,
                      expression: "isPriceLoading",
                    },
                  ],
                  attrs: { label: "", name: "1" },
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.isInitConfirmLoading,
                          expression: "isInitConfirmLoading",
                        },
                      ],
                    },
                    [
                      _c("ViewInfoConfirm", {
                        ref: "refInfoConfirm",
                        staticClass: "u-m-b-20",
                        attrs: {
                          "act-type": _vm.actType,
                          "emps-data": _vm.calcAllData.empInfos,
                          "is-add": _vm.isAdd,
                          "is-more": _vm.isMore,
                          "order-info-data": _vm.calcAllData.orderInfo,
                          "total-premium": _vm.totalPremium,
                          "unit-name": _vm.calcAllData.applicant.name,
                        },
                      }),
                      _c("ViewInvoiceConfirm", {
                        ref: "refInvoiceConfirm",
                        staticStyle: { "margin-top": "20px" },
                        attrs: {
                          insureType: _vm.insureType,
                          "is-more": _vm.isMore,
                        },
                      }),
                      _c(
                        "el-row",
                        {
                          staticClass: "u-m-t-20 u-m-b-20",
                          attrs: { justify: "center", type: "flex" },
                        },
                        [
                          _c(
                            "el-button",
                            { on: { click: _vm.onStepEditInsure } },
                            [_vm._v("<<上一步，修改保单")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                loading: _vm.isCheckingInsure,
                                type: "primary",
                              },
                              on: { click: _vm.onStepPay },
                            },
                            [_vm._v("下一步，去支付>>")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "", name: "2" } },
                [
                  _vm.currentStep === "2"
                    ? [
                        _c("choice-pay-type", {
                          staticClass: "u-m-b-20",
                          attrs: {
                            "insure-type": _vm.insureType,
                            "is-add": _vm.isAdd,
                            "is-pay-loading": _vm.isPayLoading,
                            "order-id": _vm.orderId,
                            "pay-types-data": _vm.configSetting.payTypes || [],
                            "product-id": _vm.productId,
                            "source-product-id": _vm.sourceProductId,
                            "total-price": _vm.totalPremium,
                          },
                          on: {
                            "update:isPayLoading": function ($event) {
                              _vm.isPayLoading = $event
                            },
                            "update:is-pay-loading": function ($event) {
                              _vm.isPayLoading = $event
                            },
                            onToPay: _vm.handlePayPolicy,
                          },
                        }),
                        _c(
                          "el-row",
                          { attrs: { justify: "center", type: "flex" } },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { disabled: _vm.isPayLoading },
                                on: {
                                  click: function ($event) {
                                    _vm.currentStep = "1"
                                  },
                                },
                              },
                              [_vm._v("<<上一步，确认保单")]
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "", name: "3" } },
                [
                  _vm.currentStep === "3"
                    ? [
                        _c("PayResult", {
                          attrs: {
                            "insure-type": _vm.insureType,
                            "is-add": _vm.isAdd,
                            "is-pay-loading": _vm.isPayLoading,
                            "order-id": _vm.orderId,
                            "pay-source": _vm.paySource,
                            "pay-types-data": _vm.configSetting.payTypes || [],
                            "pre-pay-notice-data":
                              _vm.configSetting.prePayNotice,
                            "product-id": _vm.productId,
                            "source-product-id": _vm.sourceProductId,
                            "temp-order-id": _vm.isAdd
                              ? _vm.endorseOrderId
                              : _vm.orderId,
                            "is-close-tag": "",
                            "total-price": _vm.totalPremium,
                          },
                          on: {
                            "update:isPayLoading": function ($event) {
                              _vm.isPayLoading = $event
                            },
                            "update:is-pay-loading": function ($event) {
                              _vm.isPayLoading = $event
                            },
                            onPayAgain: _vm.onOpenToPay,
                            onToPolicyDetail: _vm.onToPolicyDetail,
                          },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      !_vm.isAdd
        ? _c("FloatSaveBtn", {
            attrs: { loading: _vm.isAddStaging, text: "暂存保单" },
            on: {
              onFloatBtnClicked: function ($event) {
                return _vm.onSaveCache()
              },
            },
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isShowRepeatEmpDialog,
            title: "提示",
            width: "60%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShowRepeatEmpDialog = $event
            },
          },
        },
        [
          _c(
            "avue-crud",
            {
              ref: "crud",
              attrs: {
                data: _vm.repeatEmpList,
                option: _vm.optionRepeatEmployee,
                "table-loading": _vm.tableLoadingRepeatEmpList,
              },
            },
            [
              _c(
                "template",
                { slot: "menuLeft" },
                [
                  _vm._v("\n\t\t\t\t当前被保企业：\n\t\t\t\t"),
                  _vm.calcAllData.applicant
                    ? _c("span", { staticClass: "red-bold" }, [
                        _vm._v(_vm._s(_vm.calcAllData.applicant.name)),
                      ])
                    : _vm._e(),
                  _c("el-alert", {
                    staticStyle: { margin: "5px 0" },
                    attrs: {
                      closable: false,
                      title:
                        "以下投保人员已通过其他企业投保，请确认是否需要再次投保？",
                      type: "warning",
                    },
                  }),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "template",
            { staticClass: "dialog-footer", slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.isShowRepeatEmpDialog = false
                    },
                  },
                },
                [_vm._v("修改投保人员")]
              ),
              _c("el-button", { on: { click: _vm.onInsureAgain } }, [
                _vm._v("确认再次投保"),
              ]),
            ],
            1
          ),
        ],
        2
      ),
      _c("DialogRepeatEmps", {
        ref: "repeatEmpsDlg",
        on: { removeRepeatEmps: _vm.handleRemoveRepeatEmps },
      }),
      _vm.isShowInsureNumberYet
        ? _c("DialogInsureNumber", {
            ref: "insureNumber",
            attrs: { visible: _vm.isShowInsureNumberYet },
            on: {
              "update:visible": function ($event) {
                _vm.isShowInsureNumberYet = $event
              },
            },
          })
        : _vm._e(),
      _c("InsureNotices", {
        ref: "refInsureNoticesHint",
        on: {
          onConfirmAutoStatus: _vm.onConfirmAutoStatus,
          onToCancel: _vm.onToCancel,
          onToSure: _vm.onToSure,
        },
      }),
      _c(
        "BaseHintDialog",
        {
          ref: "refNewerHint",
          attrs: {
            "left-btn-content": "太忙了，稍后查看",
            "right-btn-content": "马上了解",
            "title-content": "操作须知",
          },
          on: { onBaseDialogHint: _vm.onBaseDialogHint },
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _vm._v("\n\t\t\t如何替换、加人，您知道了吗？\n\t\t\t"),
            _c("br"),
            _vm._v("\n\t\t\t如何制作精美的投保计划书，您知道吗？\n\t\t\t"),
            _c("br"),
            _vm._v("\n\t\t\t职业、工种的投保方案建议，您知道吗？\n\t\t\t"),
            _c("br"),
            _c("span", { staticClass: "red-bold" }, [
              _vm._v(
                "为了更顺畅地使用本系统，提醒您尽快完成本系统的操作指引的阅读，解锁更多实用功能！"
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }